/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.9.7",
    versionName: "0.2.0-nightly.2025.9.7",
    versionChannel: "nightly",
    buildDate: "2025-09-07T00:07:34.466Z",
    commitHash: "ef4f66eabea4929f4ca3865bd08f1b90b9796684",
};
